import React, { Component } from 'react';
import SideBar from '../SideBar/SideBar';
import './PoDetailsEdit.css'
import { API_URL } from '../config';
import axios from 'axios';
import { toast } from 'react-toastify';
import Loader from '../Utils/AnLoader/Loader'
import Swal from 'sweetalert2';

import { DateRangePicker } from 'rsuite';
import "rsuite/dist/rsuite.css";

// #root{ padding: 10px; }
export default class PoDetailsEdit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            role: localStorage.getItem('role') || '', // Get role from local storage
            data: null,
            error: null,
            poNumber: localStorage.getItem('SelectedValue'),
            loading: false,
            backButtonClicked: false,
            shipping_windows: "",
            toggle: localStorage.getItem("toggle") == "true" ? true : false,
            order_additional_details:[],
            inputValues: {
                selectAllChecked: false,
                selectedRow: [],
                orderDetails: [],
                order_details: '',
                release_details: '',
                po_type: '',
                contract_name: '',
                currency: '',
                purchasing_contact: '',
                third_party_reference: '',
                ship_to: '',
                bill_to_order_by: '',
                vendor_name: '',
                factory_name: '',
                order_id: '',
                skuList: '',
                merchandiseTotal: 0, // Added merchandiseTotal state
                grandTotal: 0, // New state for grand total

                // Add more fields as needed
            },
        };
        // this.handleToggleChange = this.handleToggleChange.bind(this);

    }

    componentDidMount() {

        var login = localStorage.getItem("token")
        if (login === null || login === undefined) window.location.href = "/";

        window.addEventListener('beforeunload', this.handleBeforeUnload);
        this.getPoDetails();
        this.setState({
            selectedRow: [],
        });

    }

    componentWillUnmount() {
        window.removeEventListener('beforeunload', this.handleBeforeUnload);
    }

    // handleToggleChange(toggle) {
    //     this.setState({ toggle });
    // }
    handleBeforeUnload = (event) => {
        if (event.currentTarget.performance.navigation.type === 2) {
            this.setState({ backButtonClicked: true });
        }
    };

    getPoDetails = () => {

        if (this.state.poNumber) {
            fetch(API_URL + '/api/po-details/?order_number=' + this.state.poNumber)
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Failed to fetch data');
                    }
                    return response.json();
                })
                .then(data => {
                    const merchandiseTotal = data.order_additional_details.reduce((total, item) => total + parseFloat(item.qty), 0);
                    this.setState({ data, merchandiseTotal });

                    // Check if data contains order_details
                    if ('order_details' in data) {
                        // If order_details exist, set inputValues from order_details
                        this.setState(prevState => ({
                            data,
                            inputValues: {
                                ...prevState.inputValues,
                                order_details: data.order_details.order_name,
                                release_details: data.order_details.release_details,
                                po_type: data.order_details.po_type,
                                contract_name: data.order_details.contract_name,
                                currency: data.order_details.currency,
                                purchasing_contact: data.order_details.purchasing_contact,
                                third_party_reference: data.order_details.third_party_reference,
                                ship_to: data.order_details.ship_to,
                                bill_to_order_by: data.order_details.bill_to_order_by,
                                vendor_name: data.order_details.vendor_name,
                                factory_name: data.order_details.factory_name,
                                // Add more fields as needed
                            }
                        }));
                    }
                    // Check if data contains order_date
                    if ('order_date' in data) {

                        if (data.order_date.shiping_window != null) {
                            const dates = data.order_date.shiping_window.split(" - ");
                            const startDate = new Date(dates[0]);
                            const endDate = new Date(dates[1]);

                            const convertedDates = [
                                startDate,
                                endDate
                            ];
                            this.setState({ shipping_windows: convertedDates })
                        } else {
                            this.setState({ shipping_windows: null })

                        }

                        // If order_date exists, set inputValues for po_date from order_date
                        this.setState(prevState => ({
                            data,
                            inputValues: {
                                ...prevState.inputValues,

                                po_date: data.order_date.po_date,
                                req_ship_date: data.order_date.req_ship_date,
                                estimated_delivery: data.order_date.estimated_delivery,
                                req_delivery_date: data.order_date.req_delivery_date,
                                cancel_date: data.order_date.cancel_date,
                                delivery_window: data.order_date.delivery_window,
                                vendor: data.order_date.vendor,
                                // shiping_window: "2024/03/29 ~ 2024/04/30",
                                department: data.order_date.department
                                // Set other fields from order_date if needed
                            }
                        }));
                    }
                    if ('order_terms' in data && data.order_terms.length > 0) {
                        // If order_terms exist and data.order_terms has elements, set inputValues for freight_terms from the first order_terms
                        this.setState(prevState => ({
                            data,
                            inputValues: {
                                ...prevState.inputValues,
                                freight_terms: data.order_terms[0].freight_terms,
                                preferred_carrier: data.order_terms[0].preferred_carrier,
                                terms_type: data.order_terms[0].terms_type,
                                terms_basis: data.order_terms[0].terms_basis,
                                terms_disc: data.order_terms[0].terms_disc,
                                disc_due_date: data.order_terms[0].disc_due_date,
                                disc_days: data.order_terms[0].disc_days,
                                net_due_date: data.order_terms[0].net_due_date,
                                net_days: data.order_terms[0].net_days,
                                description: data.order_terms[0].description



                            }
                        }));
                    }
                    if ('order_total_qty' in data && data.order_total_qty.length > 0) {
                        // If order_total_qty exist and data.order_total_qty has elements, set inputValues for freight_terms from the first order_total_qty
                        this.setState(prevState => ({
                            data,
                            inputValues: {
                                ...prevState.inputValues,
                                weight: data.order_total_qty[0].weight,
                                total_qty: data.order_total_qty[0].total_qty,
                                volumn: data.order_total_qty[0].volumn,
                                letter_notes:data.order_total_qty[0].letter_notes,
                                special_instructions:data.order_total_qty[0].special_instructions,
                            }
                        }));
                    }


                })
                .catch(error => {
                    this.setState({ error: error.message });
                });
        }
    }
    handlePoDetails = () => {
        window.location.href = '/PoDetails';
    }

    HandleUpdate = () => {

        // e.preventDefault(); // Prevent default form submission behavior if applicable

        console.log("this.state.inputValues", this.state.data)
        const url = `${API_URL}/api/update-details/${this.state.data.order_details.order_id}/`; // API endpoint URL

        const inputData = { // Assuming this is your input data
            order_name: this.state.inputValues.order_details,
            release_details: this.state.inputValues.release_details,
            po_type: this.state.inputValues.po_type,
            contract_name: this.state.inputValues.contract_name,
            currency: this.state.inputValues.currency,
            purchasing_contact: this.state.inputValues.purchasing_contact,
            third_party_reference: this.state.inputValues.third_party_reference,
            ship_to: this.state.inputValues.ship_to,
            bill_to_order_by: this.state.inputValues.bill_to_order_by,
            vendor_name: "Location ID: 03235",
            factory_name: this.state.inputValues.factory_name,
            updated_by: sessionStorage.getItem("UserName")


        };
        const inputData1 = { // Assuming this is your input data
            order_dates: {
                delivery_window: this.state.inputValues.delivery_window,
                vendor: this.state.inputValues.vendor,
                po_date: this.state.inputValues.po_date,
                req_ship_date: this.state.inputValues.req_ship_date,
                estimated_delivery: this.state.inputValues.estimated_delivery,
                req_delivery_date: this.state.inputValues.req_delivery_date,
                cancel_date: this.state.inputValues.cancel_date,
                shiping_window: this.state.inputValues.shipping_window,
                department: this.state.inputValues.department,
                updated_by: sessionStorage.getItem("UserName")
            }

        };
        const inputData2 = { // Assuming this is your input data
            order_terms: {
                freight_terms: this.state.inputValues.freight_terms,
                preferred_carrier: this.state.inputValues.preferred_carrier,
                terms_type: this.state.inputValues.terms_type,
                terms_basis: this.state.inputValues.terms_basis,
                terms_disc: this.state.inputValues.terms_disc,
                disc_due_date: this.state.inputValues.disc_due_date,
                disc_days: this.state.inputValues.disc_days,
                net_due_date: this.state.inputValues.net_due_date,
                net_days: this.state.inputValues.net_days,
                description: this.state.inputValues.description,
                updated_by: sessionStorage.getItem("UserName")
            }

        };
        const inputData3 = { // Assuming this is your input data
            order_total_qty: {

                weight: this.state.inputValues.weight,
                total_qty: this.state.inputValues.total_qty,
                volumn: this.state.inputValues.volumn,
                letter_notes:this.state.inputValues.letter_notes,
                special_instructions:this.state.inputValues.special_instructions,
                updated_by: sessionStorage.getItem("UserName")
            }

        };
       
        let order_additional_detailsData = []
        for (let i = 0; i < this.state.data.order_additional_details.length; i++) {
            if (this.state.data.order_additional_details[i].unit_price1== undefined) {
                this.state.data.order_additional_details[i].unit_price = null
            }
            const item = this.state.data.order_additional_details[i];
            const item_total = (item.unit_price || 0) * item.qty; // Calculate total value

           
            order_additional_detailsData.push({ ...item, item_total, updated_by: sessionStorage.getItem("UserName") }); // Include total value in the data
            // }
        }
        const inputData4 = { // Assuming this is your input data
            order_additional_details: [...order_additional_detailsData,],

        };

        const requestData = { ...inputData, ...inputData1, ...inputData2, ...inputData3, ...inputData4 };

        fetch(url, {
            method: 'POST', // Assuming you're using the PUT method for updating
            headers: {
                'Content-Type': 'application/json', // Assuming you're sending JSON data
            },
            body: JSON.stringify(requestData), // Convert data to JSON format
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json(); // Parse the JSON data
            })
            .then(data => {
                this.setState({ loading: true });
                this.getPoDetails();
                setTimeout(() => {
                    toast.success("PO Details Updated!");
                    this.setState({ loading: true });
                    window.location.href = '/PoDetails';
                }, 2000);
                console.log('Update successful:', data); // Log the response data
                // Handle any further actions after successful update if needed
            })
            .catch(error => {
                console.error('Error updating data:', error); // Log any errors
                // Handle error scenarios if needed
            });
    }


    handleInputChange = (e) => {
debugger
        const { name, value } = e.target;
        this.setState(prevState => ({
            inputValues: {
                ...prevState.inputValues,
                [name]: value
            }
        }));
    }
    formatDate = (date) => {
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        return `${year}/${month}/${day}`;
    }

    handleInputChange2 = (name, value, disabled) => {
        if (disabled == false) { }
        let formattedDateRange = null;

        // Check if value is defined and contains two date values
        if (value && value.length === 2) {
            const startDate = new Date(value[0]);
            const endDate = new Date(value[1]);

            if (!isNaN(startDate.getTime()) && !isNaN(endDate.getTime())) {
                const formattedStartDate = this.formatDate(startDate);
                const formattedEndDate = this.formatDate(endDate);
                formattedDateRange = `${formattedStartDate} - ${formattedEndDate}`;
            }
        }

        // Set the state with the provided name and formatted date range or null
        this.setState(prevState => ({
            inputValues: {
                ...prevState.inputValues,
                [name]: formattedDateRange // Assign formattedDateRange or null
            },
            shipping_windows: value // Set shipping_windows regardless of value being undefined or not
        }));
    }


    handleInputChange1 = (e) => {
        const { name, value } = e.target;

        // Special handling for date fields
        if (name === "po_date" || name === "req_ship_date" || name === "req_delivery_date" || name === "cancel_date") {
            // You might need additional formatting here if the date format is different
            // For example, if the date format is 'YYYY-MM-DD', you might need to parse it accordingly
            const formattedDate = value; // You might need to format the date here

            this.setState(prevState => ({
                inputValues: {
                    ...prevState.inputValues,
                    [name]: formattedDate
                }
            }));
        } else {
            // For other fields, handle normally
            this.setState(prevState => ({
                inputValues: {
                    ...prevState.inputValues,
                    [name]: value
                }
            }));
        }
    }

    handleDeleteRecord = () => {
        Swal.fire({
            title: 'Are you sure you want to delete?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: localStorage.getItem("toggle") == "true" ? '#DB4444' : '#055032',
            cancelButtonText: 'No',
            confirmButtonText: 'Yes',
        }).then((result) => {
            if (result.isConfirmed) {
                var data = { skus: this.state.selectedRow, order_id: this.state.selectedOrderIds };
                axios.delete(API_URL + `/api/delete-rows/`, { data }).then((res) => {
                    if (res && res.data) {
                        toast.success("Record Deleted !");
                        this.getPoDetails();
                        // Reset selectedRow state after successful deletion
                        this.setState({ selectedRow: [], selectedOrderIds: "" });
                        this.setState({ selectAllChecked: false });

                    } else {
                        // Handle deletion failure
                    }
                }).catch((error) => {
                    // Handle error
                });
            }
        });
    };

    handleCheckrow = (e, sku, orderId, item) => {
        ;
        if (!Array.isArray(this.state.selectedRow)) {
            console.error('selectedRow is not an array:', this.state.selectedRow);
            return; // Exit the function or handle the error appropriately
        }
        var checkItem = [...this.state.selectedRow];

        if (e.target.checked) {
            item.checked = true;
            checkItem.push(sku);
        } else {
            checkItem = checkItem.filter((selectedSku) => selectedSku !== sku);
            item.checked = false;
        }

        // Check if all checkboxes are checked
        const allChecked = this.state.data.order_additional_details.every((item) => item.checked);

        this.setState({
            selectedRow: checkItem,
            selectedOrderIds: orderId,
            // Update header checkbox state based on allChecked
            selectAllChecked: allChecked
        });
    };


    handleHeaderCheckboxChange = (e) => {
        ;
        const isChecked = e.target.checked;
        const updatedData = this.state.data.order_additional_details.map((item) => ({
            ...item,
            checked: isChecked,
        }));

        const selectedRow = isChecked ? updatedData.map((item) => item.sku) : [];
        let orderId = isChecked ? [...new Set(updatedData.map(data => data.order_id))].toString() : "";

        this.setState({
            data: {
                ...this.state.data,
                order_additional_details: updatedData,
            },
            selectedRow: selectedRow,
            selectedOrderIds: orderId,
            // Update selectAllChecked state
            selectAllChecked: isChecked
        });
    };

    



    handleUnitPriceChange = (event, index, item) => {
        const { value } = event.target;

        // Check if the input value is a non-negative decimal number
        if (/^\d*\.?\d*$/.test(value) || value === '') { // Allow empty string for clearing the input
            const newData = [...this.state.data.order_additional_details];
            newData[index].unit_price = parseFloat(value);
            newData[index].unit_price1 = parseFloat(value);

            newData[index].isUpdated = true;

            this.setState(prevState => ({
                data: {
                    ...prevState.data,
                    order_additional_details: newData
                }
            }));
        }

        // Recalculate total based on the updated unit price and quantity
        const updatedTotal = (parseFloat(value) || 0) * item.qty;
        const updatedItem = { ...item, total: updatedTotal };

        // Update the state with the updated total for the item
        const updatedAdditionalDetails = [...this.state.data.order_additional_details];
        updatedAdditionalDetails[index] = updatedItem;
        this.setState({ data: { ...this.state.data, order_additional_details: updatedAdditionalDetails } });
    }

    handleVendorPn = (event, index, item, val,val1) => {
        debugger
        var order_additional_details = this.state.data.order_additional_details
        for (let i = 0; i < order_additional_details.length; i++) {
            if (val1 == 1 && item.sku && item.sku == order_additional_details[i].sku) {
                order_additional_details[i].vendor_pn = val
            }
            else if (val1 == 2 && item.sku && item.sku == order_additional_details[i].sku) {
                order_additional_details[i].upc_gstin = val
            }
            else if (val1 == 3 && item.sku && item.sku == order_additional_details[i].sku) {
                order_additional_details[i].desc_line_item_comment = val
            }
            else if (val1 == 4 && item.sku && item.sku == order_additional_details[i].sku) {
                order_additional_details[i].marks_and_numbers = val
            }
            else if (val1 == 5 && item.sku && item.sku == order_additional_details[i].sku) {
                order_additional_details[i].qty = val
            }
            else if (val1 == 6 && item.sku && item.sku == order_additional_details[i].sku) {
                order_additional_details[i].uom = val
            }
        }
        this.setState({ order_additional_details })
    }
    




    render() {

        const { data, error, role, inputValues, merchandiseTotal } = this.state;
        const { selectAllChecked } = this.state;

        // const { role } = this.state;

        if (error) {
            return <div>Error: {error}</div>;
        }

        if (!data) {
            return <div><Loader /></div>;
        }
        const totalSum = data.order_additional_details.reduce((total, item) => total + (item.unit_price || 0) * item.qty, 0);

        return (
            this.state.loading ? <Loader /> :
                <div className="container-fluid">
                    <div className="row mt-2">
                        <div className="col-md-2">
                            <SideBar />
                        </div>
                        <div className="col-md-10">
                            <div className="container h-100 poDetailsContainer_media" style={{ marginTop: "73px", backgroundColor: "#f9fbfd", width: "96%", marginLeft: "34px" }}>
                                <div className="row m-0 p-0 align-items-center justify-content-center mb-3">
                                    <div className="col-md-8 mt-3">
                                        <h4 className='FontB'><b>PO {this.state.poNumber}</b></h4>
                                    </div>
                                    <div className="col-md-4 mt-2 m-0 p-0 text-end mt-3">
                                        <button onClick={() => this.handlePoDetails()} className="btn-sm  buttonBorder me-2" style={{ cursor: "pointer" }}>Back</button>

                                        {/* </div>
                                    <div className="col-md-2  mt-3"> */}
                                        <button type="submit" onClick={() => this.HandleUpdate()} className="btn-sm buttonBorder2G" style={{ cursor: "pointer", color: 'white' }}>Save Changes</button>

                                    </div>

                                </div>
                                <form id="myform1">
                                    <div className="row">
                                        <div className="col-md-4 mt-2">
                                            <label className="form-label">Order</label>
                                            {/* <select name="intake_type" className="common-input form-select">
                                            <option value="">Select Department</option>
                                        </select> */}
                                            <input
                                                type="text"
                                                className="form-control"
                                                disabled="true"
                                                value={inputValues.order_details}
                                                name="order_details"
                                                onChange={this.handleInputChange}
                                                required
                                                readOnly
                                            />

                                        </div>
                                        <div className="col-md-4 mt-2">
                                            <label className="form-label">Release</label>

                                            <input
                                                type="text"
                                                className="form-control"
                                                disabled={role === 'admin' ? false : true}
                                                value={inputValues.release_details}

                                                name="release_details"
                                                onChange={this.handleInputChange}
                                                required
                                            />

                                        </div>
                                        <div className="col-md-4 mt-2">
                                            <label className="form-label">PO Type</label>

                                            <input
                                                type="text"
                                                className="form-control"
                                                disabled={role === 'admin' ? false : true}
                                                value={inputValues.po_type}

                                                name="po_type"
                                                onChange={this.handleInputChange}
                                                required
                                            />

                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-4 mt-2">
                                            <label className="form-label">Contract</label>
                                            {/* <input disabled={role == 'admin' ? false : true} type="text" value="" placeholder='Contract' name="contract_name" className="form-control" required /> */}

                                            <input
                                                type="text"
                                                className="form-control"
                                                disabled={role === 'admin' ? false : true}
                                                value={inputValues.contract_name}

                                                name="contract_name"
                                                onChange={this.handleInputChange}
                                                required
                                            />

                                        </div>
                                        <div className="col-md-4 mt-2">
                                            <label className="form-label">Currency</label>
                                            {/* <input disabled={role == 'admin' ? false : true} type="text" value="" placeholder='Currency' name="currency" className="form-control" required /> */}
                                            <input
                                                type="text"
                                                className="form-control"
                                                disabled={role === 'admin' ? false : true}
                                                value={inputValues.currency}

                                                name="currency"
                                                onChange={this.handleInputChange}
                                                required
                                            />
                                        </div>
                                        <div className="col-md-4 mt-2">
                                            <label className="form-label">Purchasing Contact</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                disabled={role === 'admin' ? false : true}
                                                value={inputValues.purchasing_contact}
                                                name="purchasing_contact"
                                                onChange={this.handleInputChange}
                                                required
                                            />

                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-4 mt-2">
                                            <label className="form-label">Third Party Reference</label>
                                            {/* <input disabled={role == 'admin' ? false : true} type="text" value="" placeholder='Third Party reference' name="third_party_reference" className="form-control" required /> */}
                                            <input
                                                type="text"
                                                className="form-control"
                                                // disabled={role === 'admin' ? false : true}
                                                value="Charu Merchandising - FZCO"
                                                name="third_party_reference"
                                                onChange={this.handleInputChange}
                                                required
                                                disabled
                                            />

                                        </div>
                                        <div className="col-md-4 mt-2">
                                        </div>
                                        <div className="col-md-4 mt-2">
                                        </div>
                                    </div>
                                    <hr></hr>
                                    <div className="row">
                                        <div className="col-md-4 mt-2">
                                            <label className="form-label">PO Date</label>
                                            {/* <input disabled={role == 'admin' ? false : true} type="text" value="" placeholder='PO Date' name="amount_per_unit" className="form-control" required /> */}
                                            <input
                                                type="date"
                                                className="form-control"
                                                disabled={role === 'admin' ? false : true}
                                                value={inputValues.po_date}

                                                name="po_date"
                                                onChange={this.handleInputChange1}
                                                required
                                            />



                                        </div>
                                        <div className="col-md-4 mt-2">
                                            <label className="form-label">Request Ship Date</label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                disabled={role === 'admin' ? false : true}
                                                value={inputValues.req_ship_date}

                                                name="req_ship_date"
                                                onChange={this.handleInputChange}
                                                required
                                            />
                                        </div>
                                        <div className="col-md-4 mt-2">
                                            <label className="form-label">Request Delivery Date</label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                disabled={role === 'admin' ? false : true}
                                                value={inputValues.req_delivery_date}

                                                name="req_delivery_date"
                                                onChange={this.handleInputChange}
                                                required
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-4 mt-2">
                                            <label className="form-label">Cancel Date</label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                disabled={role === 'admin' ? false : true}
                                                value={inputValues.cancel_date}

                                                name="cancel_date"
                                                onChange={this.handleInputChange}
                                                required
                                            />

                                        </div>

                                        <div className="col-md-4 mt-2">
                                            <label className="form-label">Delivery Window</label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                disabled={role === 'admin' ? false : true}
                                                value={inputValues.delivery_window}

                                                name="delivery_window"
                                                onChange={this.handleInputChange}
                                                required
                                            />
                                        </div>

                                        <div className="col-md-4 mt-2">
                                            <label className="form-label">Department</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                disabled={role === 'admin' ? false : true}
                                                value={inputValues.department}

                                                name="department"
                                                onChange={this.handleInputChange}
                                                required
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-4 mt-2">
                                            <label className="form-label">Vendor</label>
                                            <input disabled={role === 'admin' ? false : true} type="text" onChange={this.handleInputChange} value={inputValues.vendor} name="vendor" className="form-control" required />

                                        </div>

                                        <div className="col-md-4 mt-2">
                                            <label className="form-label">Shipping Window</label>
                                            <br />
                                            {/* <input
                                                type="date"
                                                className="form-control"
                                                disabled={role === 'admin' ? false : true}
                                                value={inputValues.fromDate}
                                                name="fromDate"
                                                onChange={this.handleInputChange}
                                                required
                                            /> */}
                                            {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DemoContainer components={['SingleInputDateRangeField']}>
                                                    <DateRangePicker
                                                        slots={{ field: SingleInputDateRangeField }}
                                                        name="allowedRange"
                                                    />
                                                </DemoContainer>
                                            </LocalizationProvider> */}
                                            <DateRangePicker
                                                showOneCalendar
                                                className='Fontqw'
                                                onChange={(value) => this.handleInputChange2("shipping_window", value, role === 'admin' ? false : true)}
                                                value={this.state.shipping_windows}
                                                disabled={role === 'admin' ? false : true}
                                                required
                                                style={{ color: "black", fontSize: "15px" }}
                                                name="shipping_window"
                                                placement="bottomLeft"
                                                mode="single" // Set mode to 'single' to allow selecting only one date
                                            />


                                        </div>
                                        <div className="col-md-4 mt-2">
                                        </div>
                                    </div>
                                    <hr></hr>
                                    <div className="row">
                                        <div className="col-md-4 mt-2">
                                            <label className="form-label">Ship To</label>
                                            {/* <textarea disabled={role == 'admin' ? false : true}
                                            style={{ resize: "none" }}
                                            className="form-control"
                                            name="description"
                                            required
                                        ></textarea> */}
                                            <textarea
                                                type="text"
                                                style={{ height: "90px", resize: "none" }}
                                                className="form-control"
                                                disabled={role === 'admin' ? false : true}
                                                value={inputValues.ship_to}

                                                name="ship_to"
                                                onChange={this.handleInputChange}
                                                required
                                            />
                                        </div>
                                        <div className="col-md-4 mt-2">
                                            <label className="form-label">Ship Bill to /Ordered By</label>
                                            <textarea
                                                type="text"
                                                style={{ height: "90px", resize: "none" }}
                                                className="form-control"
                                                // disabled={role === 'admin' ? false : true}
                                                disabled
                                                value="Location ID: Charu Merchandising FZCO - IFZA BUSINESS PARK PREMISES NUMBER: 40685 – 001 A1 – 3641379065 DUBAI SILICON OASIS,DUBAI, UNITED ARAB EMIRATES"
                                                name="bill_to_order_by"
                                                onChange={this.handleInputChange}
                                                required
                                            />

                                        </div>
                                        <div className="col-md-4 mt-2">
                                            <label className="form-label">Vendor</label>
                                            <textarea
                                                type="text"
                                                style={{ height: "80px", resize: "none" }}
                                                className="form-control"
                                                // disabled={role === 'admin' ? false : true}
                                                disabled
                                                value="Location ID: 03235"
                                                name="vendor_name"
                                                onChange={this.handleInputChange}
                                                required
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-4 mt-2">
                                            <label className="form-label">Factory</label>
                                            {/* <textarea
                                            style={{ resize: "none" }}
                                            className="form-control"
                                            name="description"
                                            required
                                        ></textarea> */}
                                            <textarea
                                                type="text"
                                                style={{ resize: "none" }}
                                                className="form-control"
                                                value={inputValues.factory_name}

                                                name="factory_name"
                                                onChange={this.handleInputChange}
                                                required
                                            />
                                        </div>

                                    </div>
                                    <hr></hr>
                                    <div className="row">
                                        <div className="col-md-4 mt-2">
                                            <label className="form-label">Freight Terms</label>
                                            {/* <input disabled={role == 'admin' ? false : true} type="text" value="" placeholder='Freight Terms' name="amount_per_unit" className="form-control" required /> */}
                                            <input
                                                type="text"
                                                className="form-control"
                                                disabled={role === 'admin' ? false : true}
                                                value={inputValues.freight_terms}

                                                name="freight_terms"
                                                onChange={this.handleInputChange}
                                                required
                                            />

                                        </div>
                                        <div className="col-md-4 mt-2">
                                            <label className="form-label">Preferred Carrier</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                disabled={role === 'admin' ? false : true}
                                                value={inputValues.preferred_carrier}

                                                name="preferred_carrier"
                                                onChange={this.handleInputChange}
                                                required
                                            />
                                        </div>
                                        <div className="col-md-4 mt-2">
                                            <label className="form-label">Terms Type</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                disabled={role === 'admin' ? false : true}
                                                value={inputValues.terms_type}

                                                name="terms_type"
                                                onChange={this.handleInputChange}
                                                required
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-4 mt-2">
                                            <label className="form-label">Terms Basis</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                // disabled={role === 'admin' ? false : true}
                                                value="Auto Discount"
                                                name="terms_basis"
                                                // onChange={this.handleInputChange}
                                                required
                                                disabled
                                            />

                                        </div>
                                        <div className="col-md-4 mt-2">
                                            <label className="form-label">Terms disc%</label>
                                            {/* <input disabled={role == 'admin' ? false : true} type="text" value="" placeholder='Terms disc%' name="amount_per_unit" className="form-control" required /> */}
                                            <input
                                                type="number"
                                                className="form-control"
                                                disabled={role === 'admin' ? false : true}
                                                value={inputValues.terms_disc}
                                                onInput={(e) => {
                                                    e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 50)
                                                }}
                                                name="terms_disc"
                                                onChange={this.handleInputChange}
                                                required

                                            />
                                        </div>
                                        <div className="col-md-4 mt-2">
                                            <label className="form-label">Disc. Due Date</label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                disabled={role === 'admin' ? false : true}
                                                value={inputValues.disc_due_date}

                                                name="disc_due_date"
                                                onChange={this.handleInputChange}
                                                required
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-4 mt-2">
                                            <label className="form-label">Disc. Days</label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                disabled={role === 'admin' ? false : true}
                                                value={inputValues.disc_days}
                                                onInput={(e) => {
                                                    e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 50)
                                                }}
                                                name="disc_days"
                                                onChange={this.handleInputChange}
                                                required
                                            />

                                        </div>
                                        <div className="col-md-4 mt-2">
                                            <label className="form-label">Net Days</label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                disabled={role === 'admin' ? false : true}
                                                value={inputValues.net_days}
                                                onInput={(e) => {
                                                    e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 50)
                                                }}
                                                name="net_days"
                                                onChange={this.handleInputChange}
                                                required
                                            />

                                        </div>
                                        <div className="col-md-4 mt-2">
                                            <label className="form-label">Net Due Date</label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                disabled={role === 'admin' ? false : true}
                                                value={inputValues.net_due_date}

                                                name="net_due_date"
                                                onChange={this.handleInputChange}
                                                required
                                            />
                                        </div>
                                        <div className="col-md-4 mt-2 col-12 mt-2">
                                            <label className="form-label">Description</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                disabled={role === 'admin' ? false : true}
                                                value={inputValues.description}

                                                name="description"
                                                onChange={this.handleInputChange}
                                                required
                                            />

                                        </div>

                                    </div>
                                    <hr></hr>


                                </form>
                                {/* <hr style={{ marginTop: "72px" }} /> */}
                                <div class="table-responsive">
                                    <div className='row mb-3'>
                                        <div className='col-md-12'>
                                            <button className="btn-primary1 p-2" style={{ border: "1px solid burlywood" }} onClick={this.handleDeleteRecord}>Delete</button>
                                        </div>
                                    </div>
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th scope="col"><input type="checkbox" onChange={this.handleHeaderCheckboxChange} checked={selectAllChecked} /></th>
                                                <th scope="col">LINE</th>
                                                <th scope="col">SKU</th>
                                                <th scope="col" style={{ minWidth: "200px" }}>VENDOR PN</th>
                                                <th scope="col" style={{ minWidth: "150px" }}>UPC/GTIN</th>
                                                <th scope="col" style={{ minWidth: "300px" }}>DESCRIPTION LINE ITEM COMMENTS</th>
                                                <th scope="col" style={{ minWidth: "150px" }}>MARKS AND NUMBERS</th>
                                                <th scope="col" style={{ minWidth: "150px" }}>UNIT COST/RETAIL PRICE </th>
                                                <th scope="col" style={{ minWidth: "150px" }}>QTY </th>
                                                <th scope="col" style={{ minWidth: "150px" }}>UOM </th>
                                                <th scope="col" style={{ minWidth: "150px" }}>ITEM TOTAL </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {/* Map over the fetched data to render table rows */}
                                            {data.order_additional_details.map((item, index) => (
                                                <tr key={item.line_id}>
                                                    <td><input type="checkbox" checked={item.checked || false} onChange={(e) => this.handleCheckrow(e, item.sku, item.order_id, item)} /></td>
                                                    <td>{index + 1}</td>
                                                    <td>{item.sku}</td>
                                                    <td>
                                                    <textarea
                                                    rows="5" cols="500"
                                                            name="vendor_pn"
                                                            className="form-control"
                                                            value={(item.vendor_pn || "")}
                                                            disabled={role === 'admin' ? false : true}
                                                            onChange={(event) => this.handleVendorPn(event, index, item, event.target.value,1)}
                                                            required
                                                        />

                                                    </td>
                                                    <td> 
                                                    <textarea
                                                    rows="5" cols="500"
                                                            name="upc_gstin"
                                                            className="form-control"
                                                            value={(item.upc_gstin || "")}
                                                            disabled={role === 'admin' ? false : true}

                                                            onChange={(event) => this.handleVendorPn(event, index, item, event.target.value,2)}
                                                            required
                                                        /></td>
                                                    <td>
                                                    <textarea
                                                    rows="5" cols="1000"
                                                            name="desc_line_item_comment"
                                                            className="form-control"
                                                            value={(item.desc_line_item_comment || "")}
                                                            disabled={role === 'admin' ? false : true}
                                                            onChange={(event) => this.handleVendorPn(event, index, item, event.target.value,3)}
                                                            required
                                                        />
                                                    </td>
                                                    <td>
                                                    <input
                                                            type="text"
                                                            name="marks_and_numbers"
                                                            className="form-control"
                                                            value={(item.marks_and_numbers || "")}
                                                            disabled={role === 'admin' ? false : true}
                                                            onChange={(event) => this.handleVendorPn(event, index, item, event.target.value,4)}
                                                            required
                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="number"
                                                            name="unit_price"
                                                            className="form-control"
                                                            value={(item.unit_price1 ? item.unit_price1:item.unit_price1 == 0 ? item.unit_price1 :"")}
                                                            
                                                            onChange={(event) => this.handleUnitPriceChange(event, index, item)}
                                                            min="0"
                                                            step="0.01"
                                                            required
                                                        />
                                                    </td>

                                                    <td>
                                                    <input
                                                            type="text"
                                                            name="qty"
                                                            className="form-control"
                                                            value={(item.qty || "")}
                                                            disabled={role === 'admin' ? false : true}
                                                            onChange={(event) => this.handleVendorPn(event, index, item, event.target.value,5)}
                                                            required
                                                        />
                                                    </td>
                                                    <td>
                                                    <input
                                                            type="text"
                                                            name="uom"
                                                            className="form-control"
                                                            value={(item.uom || "")}
                                                            disabled={role === 'admin' ? false : true}
                                                            onChange={(event) => this.handleVendorPn(event, index, item, event.target.value,6)}
                                                            required
                                                        />
                                                    </td>
                                                    {/* <td>{item.item_total}</td> */}
                                                    <td>
                                                        <input
                                                            type="number"
                                                            value={item.unit_price1 ? (item.unit_price1 * item.qty).toFixed(2) : ""}
                                                            name="total"
                                                            className="form-control"
                                                            readOnly
                                                            disabled
                                                        />
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                        <tfoot className='Font'>
                                            <tr>
                                                <td colSpan="8" style={{ textAlign: "right" }}>Merchandise Total</td>
                                                <td>{merchandiseTotal.toFixed(2)}</td> {/* Display merchandiseTotal */}
                                                <td colSpan="1"></td>
                                                <td>{(totalSum.toFixed(2) || "")}
                                                </td> {/* Display totalSum */}
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>

                                <hr />
                                <div className='row'>
                                    <h5 >ALLOWANCE, CHARGES AND TAX INFORMATION:</h5>
                                </div>
                                <hr />

                                <div className='row'>
                                    <div className='col-md-12 col-sm-12'>
                                        <div style={{ overflowX: 'auto' }}>
                                            <table className='table table-bordered'>
                                                <thead >
                                                    <tr>
                                                        <th>TYPE</th>
                                                        <th>SERVICE TYPE</th>
                                                        <th>PERCENT</th>
                                                        <th>RATE</th>
                                                        <th>QTY</th>
                                                        <th>UMO</th>
                                                        <th>DESCRIPTION</th>
                                                        <th>AMOUNT</th>

                                                    </tr>
                                                </thead>
                                                <tbody className='Font'>
                                                    <tr>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>

                                                    </tr>
                                                </tbody>

                                            </table>
                                        </div>
                                    </div>
                                </div>
                                {/* <div className='row font1'>
                                    <div className='col-md-12 col-sm-3'>
                                        <span>Note/Comments/Special Instructions:</span>
                                    </div>
                                    <div className='col-md-12'>
                                        <span>Letters or Notes: GEN By accepting this purchase order you are unconditionally accepting the Dollar Tree Merchandising </span>
                                    </div>
                                </div> */}
                                <div className='row font1 d-flex'>
                                    <div className='col-md-2'>
                                        <span>Note/Comments/Special Instructions:</span>
                                    </div>
                                    <div className='col-md-3'>
                                        <textarea  rows="2" cols="100" disabled={role === 'admin' ? false : true}
                                            onChange={this.handleInputChange}
                                            value={inputValues.special_instructions}
                                            name="special_instructions" className="form-control" required />
                                    </div>
                                </div>
                                <div className='row font1 d-flex mt-2'>
                                    <div className='col-md-2'>
                                        <span>Letters or Notes:</span>
                                    </div>
                                    <div className='col-md-3'>
                                        <textarea  rows="2" cols="100" disabled={role === 'admin' ? false : true}
                                            onChange={this.handleInputChange}
                                            value={inputValues.letter_notes}
                                            name="letter_notes" className="form-control" required />
                                    </div>
                                </div>
                                <div className='row font1 d-flex mt-2'>
                                    <div className='col-md-2'>
                                        <span>Estimated Delivery:</span>
                                    </div>
                                    <div className='col-md-3'>
                                        <input type="date" disabled={role === 'admin' ? false : true}
                                            onChange={this.handleInputChange}
                                            value={inputValues.estimated_delivery}
                                            name="estimated_delivery" className="form-control" required />
                                    </div>
                                </div>

                                <hr />
                                <div className="row">
                                    <div className='col-md-3 mt-2'>
                                        {/* <span>Total qty: </span>
                                    <span></span> */}
                                        <label className="form-label">TOTAL QTY</label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            // disabled={role === 'admin' ? false : true}
                                            value={merchandiseTotal.toFixed(2)}
                                            onInput={(e) => {
                                                e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 50)
                                            }}
                                            name="total_qty"
                                            onChange={this.handleInputChange}
                                            required
                                            disabled
                                        />

                                    </div>
                                    <div className='col-md-3 mt-2'>
                                        {/* <span>Total qty: </span>
                                    <span></span> */}
                                        <label className="form-label">WEIGHT</label>
                                        {/* <input type="text" value="" disabled={role === 'admin' ? false : true} placeholder='Weight' name="amount_per_unit" className="form-control" required /> */}
                                        <input
                                            type="text"
                                            className="form-control"
                                            disabled={role === 'admin' ? false : true}
                                            value={inputValues.weight}

                                            name="weight"
                                            onChange={this.handleInputChange}
                                            required
                                        />


                                    </div>
                                    <div className='col-md-3 mt-2'>
                                        {/* <span>Total qty: </span>
                                    <span></span> */}
                                        <label className="form-label">VOLUME</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            disabled={role === 'admin' ? false : true}
                                            value={inputValues.volumn}

                                            name="volumn"
                                            onChange={this.handleInputChange}
                                            required
                                        />


                                    </div>
                                    <div className='col-md-3 mt-2'>
                                        <label className="form-label">PURCHASE ORDER TOTAL</label>
                                        <input type="text" value={totalSum.toFixed(2)} readOnly disabled placeholder='Purchase order total' name="amount_per_unit" className="form-control" required />

                                    </div>
                                </div>
                                <hr className='mb-5' />
                            </div>
                        </div>
                    </div>
                </div>
        );
    }
}

